import React from 'react';
import RecentActivityPageContent from '../../RecentActivity/Components/RecentActivityPageContent';

export default function RecentActivityPage() {
    return <RecentActivityPageContent />;
}
